module.exports = __webpack_public_path__ + "static/media/raccoon.312dd495.webp";